import { Box, Progress, Stack, Text } from '@chakra-ui/react';

import { useI18n } from '~/hooks/use-i18n';

import { PlayButton } from './play-button';

export function PlayProgressBar({
  playButtonHref,
  playButtonAriaLabel,
  percentComplete,
  progressAriaLabel,
  variant = 'blue',
  onPlayButtonClick,
}: {
  playButtonHref: string;
  playButtonAriaLabel: string;
  percentComplete: number;
  variant?: 'blue' | 'white';
  progressAriaLabel: string;
  onPlayButtonClick?: () => void;
}) {
  const { t } = useI18n();
  const overrideColor = variant === 'white' ? 'white' : 'blue.500';
  const progressBarBg = variant === 'white' ? 'gray.700' : 'gray.200';
  const progressBarTextColor = variant === 'white' ? 'white' : 'black';
  const playButtonBackgroundColor = variant === 'white' ? 'transparent' : 'white';

  return (
    <>
      <Box position='relative' zIndex={2}>
        <PlayButton
          ariaLabel={playButtonAriaLabel}
          backgroundColor={playButtonBackgroundColor}
          href={playButtonHref}
          overrideColor={overrideColor}
          onClick={onPlayButtonClick}
        />
      </Box>
      <Stack alignItems='flex-start' flex={1} spacing='4px' width='100%'>
        <Progress
          aria-label={progressAriaLabel}
          bg={progressBarBg}
          data-testid='catalog-card-progress-bar'
          size='sm'
          value={percentComplete}
          width='100%'
          css={{
            '[role="progressbar"]': {
              background: overrideColor,
            },
            pointerEvents: 'none',
          }}
        />
        <Text color={progressBarTextColor} fontWeight='600' size='small-label'>
          {t('common.percent', { val: percentComplete })}
        </Text>
      </Stack>
    </>
  );
}
